import { AccountSearchIcon } from './AccountSearchIcon';

/**
 * author: GreenTurtwig
 * id 48E9C474-C544-4868-9966-C3A8D7808FCA
 * name account-search
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-search.svg
 * tags
 * - Account / User 
 */
export const UserSearchIcon = AccountSearchIcon;
export default UserSearchIcon